import { useGlobalExperiencesSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalExperiencesSearch'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import ExperiencesSearchControls from 'components/Search/Experiences/ExperiencesSearchControls'

function GlobalExperiencesSearchTabContent() {
  const { globalExperiencesSearchDispatch, globalExperiencesSearchState } = useGlobalExperiencesSearchContext()

  return <GlobalSearchContextProvider
    state={globalExperiencesSearchState}
    dispatch={globalExperiencesSearchDispatch}
  >
    <ExperiencesSearchControls />
  </GlobalSearchContextProvider>
}

export default GlobalExperiencesSearchTabContent
